// extracted by mini-css-extract-plugin
module.exports = {"stories":"Stories_stories__1m_rZ","active":"Stories_active__2D5_1"};